// tsup congela process.env.WIDGETS_ASSET_HOST en build:lib; el fallback cubre dev y tests.
export const WIDGETS_ASSET_HOST =
  process.env.WIDGETS_ASSET_HOST || 'https://widget.adipa.dev';
